import { actions } from '@~/actions/side-modal';

const initialState = null;

export default function defaultExport(state = initialState, { type, payload }) {
  switch (type) {
    case actions.OPEN_SIDE_MODAL:
      return payload;
    case actions.CLOSE_SIDE_MODAL:
      return null;
    default:
      return state;
  }
}
